import get from "lodash/get";
import React, { FC, useEffect, useRef, useState } from "react";
import { Input, SearchIcon } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";
import { Waypoint } from "react-waypoint";

import Preloader from "~/components/Preloader";
import { useSetLocationData } from "~/hooks/locationData";
import { useGetUsersQuery } from "~/schemas/generated/graphql";

import s from "./SelectDealerForm.less";

interface IProps {
  pkd?: boolean;
}

const SelectUserForm: FC<IProps> = ({ pkd = false }) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const containerRef = useRef(null);
  const [searchText, setSearchText] = useState("");

  const { data, loading, fetchMore } = useGetUsersQuery({
    variables: {
      page: 0,
      count: 25,
      searchText,
    },
    fetchPolicy: "cache-and-network",
  });

  const users = get(data, "UserGetter.getUsers.items", []) as {
    fullname?: string;
    id?: string;
  }[];

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollBottom = 80;
    }
  }, [containerRef.current]);

  const onScrollBottom = () => {
    fetchMore({
      variables: {
        page: Math.ceil(users.length / 25),
      },
      updateQuery: ({ UserGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) return { UserGetter };
        return {
          UserGetter: {
            ...UserGetter,
            getUsers: {
              ...UserGetter.getUsers,
              items: [
                ...UserGetter.getUsers.items,
                ...get(fetchMoreResult, "UserGetter.getUsers.items", []),
              ],
            },
          },
        };
      },
    });
  };

  const setUser = (e) => {
    pkd
      ? setData("UserId", e.target.dataset.user_id)
      : setData(
          "openModal",
          "",
          "UserId",
          e.target.dataset.user_id,
          "searchText",
          e.target.dataset.user_name,
        );
  };

  return (
    <div className={s.select_dealer_wrap}>
      <Input
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder={t("ui.search")}
        prefix={<SearchIcon size={16} />}
        allowClear
      />
      <div className={s.deaelers_container} ref={containerRef}>
        {users.map(({ fullname, id }) => (
          <div
            className={s.dealer_name}
            key={id}
            data-user_id={id}
            data-user_name={fullname}
            onClick={setUser}
          >
            {fullname}
          </div>
        ))}
        {loading && <Preloader />}
        {users.length > 24 && <Waypoint onEnter={onScrollBottom} />}
      </div>
    </div>
  );
};

export default SelectUserForm;
